export default __webpack_public_path__ + "static/media/Henry.34f22741.png";